import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { ReceiptIcon } from '@phosphor-icons/react';
import {
  Route as pathlessAuthenticatedRoute,
  requireAnyPermission,
  requireModules,
} from '../route';

// The legacy Sales Orders page, moved here from /sales-orders when OMS v3
// took over the unversioned path. Its components intentionally stay in
// ../sales-orders/ (folder not renamed to avoid churn). Served to tenants
// whose org does not have `orderManagement.enhancedSalesOrderUi` enabled;
// visibility is governed purely by RBAC (Read/SalesOrderDraft).
const SalesOrderDraftsPage = lazyRouteComponent(
  () => import('../sales-orders/SalesOrderDraftsPage'),
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/sales-orders-v2',
  staticData: {
    app: {
      nav: {
        label: 'Sales Orders',
        icon: <ReceiptIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 20,
      },
      access: {
        modulesAnyOf: [ProductModule.ORDER_MANAGEMENT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SalesOrderDraft },
        ],
      },
    },
  },
  component: SalesOrderDraftsPage,
  loader: () => ({
    crumb: 'Sales Orders',
  }),
  beforeLoad: async ({ context }) => {
    requireModules({
      context,
      oneOf: [ProductModule.ORDER_MANAGEMENT],
    });
    await requireAnyPermission({
      context,
      permissions: [
        { action: Action.Read, subject: Subject.SalesOrderDraft },
        { action: Action.Read, subject: Subject.SalesOrder },
      ],
    });
  },
  validateSearch: z.object({
    salesOrderId: z.string().optional(),
  }),
});
